import { RouterModule } from '@angular/router';
import { CUSTOM_ELEMENTS_SCHEMA, ErrorHandler, NgModule } from '@angular/core';
import { CommonModule, TitleCasePipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// MATERIAL
import { MaterialModule } from '../material-module';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatCardModule } from '@angular/material/card';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatChipsModule } from '@angular/material/chips';

// Shared components
import { StatusBadgeComponent } from '../components/status-badge/status-badge.component';
import { FooterComponent } from '../components/footer/footer.component';
import { SelectInputComponent } from '../components/forms/select-input/select-input.component';
import { TextInputComponent } from '../components/forms/text-input/text-input.component';
import { TextareaInputComponent } from '../components/forms/textarea-input/textarea-input.component';
import { SmallFooterComponent } from '../components/small-footer/small-footer.component';
import { QRCodeComponent } from 'angularx-qrcode';
import { QrGeneratorComponent } from '../components/qr-scanner/qr-generator/qr-generator.component';
import { DialogConfirmComponent } from '../components/dialog-confirm/dialog-confirm.component';

// Shared pipes
import { TranslateAttributePipe } from '../pipes/translate-attribute/translate-attribute.pipe';

// Shared directives
import { TabQuerySyncDirective } from '../directives/tab-query-sync.directive';
import { TabUrlKeyDirective } from '../directives/tab-url-key.directive';

// Shared modules
import { TranslocoRootModule } from '../transloco-root.module';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { JWTInterceptor } from '../jwtInterceptor';
import { NewTokenInterceptor } from '../newTokenInterceptor';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MY_FORMATS } from '../models/dateFormats';
import { DynamicMomentDateAdapter } from '../models/dynamic-date-adapter';
import { ErrorHandlerService } from '../services/errorHandler.service';
import { ModuleHeaderComponent } from '../components/module-header/module-header.component';
import { BaseChartDirective, provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { BackOffice24OrderEditComponent } from '../home/admin/back-office24/back-office24-orders/back-office24-order-edit/back-office24-order-edit.component';
import { BackOffice24OrderShuttleEditComponent } from '../home/admin/back-office24/back-office24-orders/back-office24-order-shuttle-edit/back-office24-order-shuttle-edit.component';
@NgModule({
  declarations: [
    StatusBadgeComponent,
    FooterComponent,
    SelectInputComponent,
    TextInputComponent,
    TextareaInputComponent,
    SmallFooterComponent,
    DialogConfirmComponent,
    QrGeneratorComponent,
    ModuleHeaderComponent,
    BackOffice24OrderEditComponent,
    BackOffice24OrderShuttleEditComponent,
    TabQuerySyncDirective,
    TabUrlKeyDirective
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    MatGridListModule,
    MatCardModule,
    MatMenuModule,
    MatIconModule,
    MatButtonModule,
    MatSortModule,
    MatTableModule,
    MatChipsModule,
    TranslocoRootModule,
    TranslateAttributePipe,
    TitleCasePipe,
    QRCodeComponent,
    BaseChartDirective,
    RouterModule
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    MatGridListModule,
    MatCardModule,
    MatMenuModule,
    MatIconModule,
    MatButtonModule,
    MatSortModule,
    MatTableModule,
    MatChipsModule,
    StatusBadgeComponent,
    FooterComponent,
    SelectInputComponent,
    TextInputComponent,
    TextareaInputComponent,
    SmallFooterComponent,
    DialogConfirmComponent,
    ModuleHeaderComponent,
    BaseChartDirective,
    TranslateAttributePipe,
    TranslocoRootModule,
    QRCodeComponent,
    QrGeneratorComponent,
    RouterModule,
    BackOffice24OrderEditComponent,
    BackOffice24OrderShuttleEditComponent,
    TabQuerySyncDirective,
    TabUrlKeyDirective
  ],
  providers: [
    provideCharts(withDefaultRegisterables()),
    { provide: MatDialogRef, useValue: {} },
    { provide: MAT_DIALOG_DATA, useValue: {} },
    { provide: MatBottomSheetRef, useValue: {} },
    { provide: MAT_BOTTOM_SHEET_DATA, useValue: {} },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: JWTInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: NewTokenInterceptor,
      multi: true
    },
    {
      provide: DateAdapter,
      useClass: DynamicMomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    { provide: MAT_DATE_LOCALE, useValue: 'sv-SE' },
    { provide: ErrorHandler, useClass: ErrorHandlerService },
    provideHttpClient(withXhr(), withInterceptorsFromDi()),
  ]
})
export class SharedModule { }
